import { render, staticRenderFns } from "./PreviousReleaseBanner.vue?vue&type=template&id=088995a6&scoped=true&"
import script from "./PreviousReleaseBanner.vue?vue&type=script&lang=js&"
export * from "./PreviousReleaseBanner.vue?vue&type=script&lang=js&"
import style0 from "./PreviousReleaseBanner.vue?vue&type=style&index=0&id=088995a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088995a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('088995a6')) {
      api.createRecord('088995a6', component.options)
    } else {
      api.reload('088995a6', component.options)
    }
    module.hot.accept("./PreviousReleaseBanner.vue?vue&type=template&id=088995a6&scoped=true&", function () {
      api.rerender('088995a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/PreviousReleaseBanner.vue"
export default component.exports